import { COURSE_ITEM_API, COURSE_DISCOUNT_API, COURSE_TABS_API, SERIES_API, COURSE_LIVE_API, SHOPPING_CART_API, VOD_API } from "../constants/api-constants";
import { axiosInstance } from '../axios/axiosConfig';

export const getSeriesList = async (params) => {
  try {
    const response = await axiosInstance.post(SERIES_API.GET_SERIES_API, JSON.stringify(params));
    return response.data || [];
  } catch (error) {
    throw new Error(SERIES_API.GET_SERIES_API_ERROR_STRING);
  }
};

export const getCoursesSearchData = async (options) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.get(COURSES_API.GET_COURSES_SEARCH_API, { params: options });
    return response.data;
  } catch (error) {
    // throw new Error(COURSES_API.GET_COURSES_SEARCH_API_ERROR_STRING);
    console.error(COURSES_API.GET_COURSES_SEARCH_API_ERROR_STRING);
    let response = [];
    const dummySearchResponse = async (str) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          response = [...Array(10).keys()].map((item) => str + "-" + item);
          resolve(response);
        }, 1000);
      });
    };
    await dummySearchResponse(options.queryString);
    return response;
  }
};

export const getCourseDiscountData = async (options) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.get(COURSE_DISCOUNT_API.GET_COURSE_DISCOUNT_API, { params: options });
    return response.data;
  } catch (error) {
    // throw new Error(COURSE_DISCOUNT_API.GET_COURSE_DISCOUNT_API_ERROR_STRING);
    console.error(COURSE_DISCOUNT_API.GET_COURSE_DISCOUNT_API_ERROR_STRING);
    return Array.from({ length: 3 }, (_, index) => ({
      id: index,
      title: "Giảm giá 30%",
      subtitle: "Cho người mới bắt đầu",
      code: "COFFEELOVER",
      remainingTime: 45645,
      description: ["Không thể kết hợp với các phiếu giảm giá hoặc khuyến mãi khác", "Chỉ có trên các khóa học có giá đầy đủ"],
    }));
  }
};

export const getCourseTabsData = async (options) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.get(COURSE_TABS_API.GET_COURSE_TABS_API, { params: options });
    return response.data;
  } catch (error) {
    // throw new Error(COURSE_TABS_API.GET_COURSE_TABS_API_ERROR_STRING);
    console.error(COURSE_TABS_API.GET_COURSE_TABS_API_ERROR_STRING);
    return [
      {
        label: "Tất cả",
        icon: "pi pi-book",
        key: "",
        index: 0,
      },
      {
        label: "Sơ cấp",
        icon: "pi pi-book",
        key: "primary",
        index: 1,
      },
      {
        label: "Trung cấp",
        icon: "pi pi-book",
        key: "intermediate",
        index: 2,
      },
      {
        label: "TOPIK",
        icon: "pi pi-book",
        key: "topik",
        index: 3,
      },
      {
        label: "Giao tiếp trong kinh doanh",
        icon: "pi pi-book",
        key: "business-communication",
        index: 4,
      },
      {
        label: "Trọn bộ",
        icon: "pi pi-book",
        key: "full-set",
        index: 5,
      },
      {
        label: "Khóa học khác",
        icon: "pi pi-book",
        key: "other",
        index: 6,
      },
    ];
  }
};

export const getCourseDetailData = async (id) => {
  try {
    const response = await axiosInstance.get(`${COURSE_ITEM_API.GET_COURSE_ITEM_API}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(COURSE_ITEM_API.GET_COURSE_DETAIL_API_ERROR_STRING);
  }
};

export const getCourseItemReviewData = async (id) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.get(`${COURSE_ITEM_API.GET_COURSE_ITEM_REVIEW_API}/${id}`);
    return response.data;
  } catch (error) {
    // throw new Error(COURSE_ITEM_API.GET_COURSE_ITEM_REVIEW_API_ERROR_STRING);
    console.error(COURSE_ITEM_API.GET_COURSE_ITEM_REVIEW_API_ERROR_STRING);
    return {
      title: "Đánh giá khóa học",
      totalReview: {
        rating: "4.0",
        starValue: [75, 21, 8, 4, 1],
        starInfo: ["75%", "21%", "3%", "1%", "< 1%"],
      },
      studentReview: [
        {
          id: 1,
          name: "Lê Văn Hùng",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Chị Minh Anh là một giảng viên tuyệt vời! Chị luôn tận tâm và nhiệt huyết trong mỗi buổi học. Phương pháp giảng dạy của chị rất sinh động và dễ hiểu, giúp tôi nhanh chóng nắm bắt ngữ pháp và từ vựng tiếng Hàn. Học với chị, tôi không chỉ học được tiếng Hàn mà còn hiểu thêm về văn hóa Hàn Quốc.",
        },
        {
          id: 2,
          name: "Dianne Russell",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Tôi rất ấn tượng với cách giảng dạy của chị Minh Anh. Chị có khả năng giải thích các khái niệm phức tạp một cách đơn giản và dễ tiếp thu. Những buổi học với chị luôn thú vị và đầy cảm hứng. Cảm ơn chị đã giúp tôi cải thiện kỹ năng tiếng Hàn của mình!",
        },
        {
          id: 3,
          name: "Trần Thị Mai",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Chị Minh Anh là một giảng viên rất nhiệt tình và chu đáo. Chị luôn sẵn sàng hỗ trợ và giải đáp mọi thắc mắc của học viên. Những bài tập và hoạt động trong lớp học rất thiết thực và giúp tôi áp dụng tiếng Hàn vào cuộc sống hàng ngày.",
        },
        {
          id: 4,
          name: "Phạm Anh Tú",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Giáo viên Minh Anh không chỉ giỏi về ngôn ngữ mà còn am hiểu sâu về văn hóa Hàn Quốc. Điều này giúp tôi không chỉ học được tiếng Hàn mà còn hiểu rõ hơn về các phong tục và truyền thống của Hàn Quốc. Rất cảm ơn chị đã tạo ra những giờ học tuyệt vời!",
        },
        {
          id: 5,
          name: "Mai Xuân Phúc",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Chị Minh Anh không chỉ là một giảng viên giỏi mà còn là một người rất thân thiện và dễ gần. Chị luôn tạo ra một môi trường học tập tích cực và động viên chúng tôi phát huy hết khả năng của mình. Tôi cảm thấy mình đã tiến bộ rất nhiều trong việc học tiếng Hàn nhờ vào sự chỉ dẫn và hỗ trợ của chị.",
        },
        {
          id: 6,
          name: "Hoàng Thị Như",
          time: "1 tuần trước",
          rating: 5,
          review:
            "Tôi thực sự ấn tượng với sự chuẩn bị kỹ lưỡng và sự chú ý đến chi tiết của chị Minh Anh trong mỗi bài giảng. Các bài học của chị luôn được chuẩn bị một cách tỉ mỉ, và chị luôn đưa ra những phản hồi chính xác và hữu ích. Học với chị là một trải nghiệm học tập tuyệt vời.",
        },
      ],
    };
  }
};

export const getCourseLiveData = async () => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.get(COURSE_LIVE_API.GET_COURSE_LIVE_API);
    return response.data;
  } catch (error) {
    // throw new Error(COURSE_LIVE_API.GET_COURSE_LIVE_API_ERROR_STRING);
    console.error(COURSE_LIVE_API.GET_COURSE_LIVE_API_ERROR_STRING);
    return {
      name: "Jung Soo Min",
      title: "Nghệ thuật giao tiếng trong tiếng Hàn - Khóa III",
    };
  }
};

export const postCourseItemRegisterData = async (data) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.post(COURSE_ITEM_API.POST_COURSE_ITEM_REGISTER_API, data);
    return response.data;
  } catch (error) {
    throw new Error(COURSE_ITEM_API.POST_COURSE_ITEM_REGISTER_API_ERROR_STRING);
  }
};

export const postCourseItemAddToCartData = async (data) => {
  try {
    const response = await axiosInstance.post(SHOPPING_CART_API.ADD_SHOPPING_CART_ITEM, {
      productId: data,
    });
    return response.data;
  } catch (error) {
    throw new Error(COURSE_ITEM_API.POST_COURSE_ITEM_REGISTER_API_ERROR_STRING);
  }
};

export const postCourseItemLikeData = async (data) => {
  try {
    const response = await axiosInstance.post(COURSE_ITEM_API.POST_COURSE_ITEM_LIKE_API, data);
    return response.data;
  } catch (error) {
    throw new Error(COURSE_ITEM_API.POST_COURSE_ITEM_LIKE_API_ERROR_STRING);
  }
};

export const getUserCartDetail = async (productIds) => {
  try {
    const response = await axiosInstance.post(SHOPPING_CART_API.GET_SHOPPING_CART_DETAIL, {
      productIds
    });
    return response.data;
  } catch (error) {
    throw new Error(SHOPPING_CART_API.GET_SHOPPING_CART_DETAIL_ERROR_STRING);
  }
}
export const postCourseBookmark = async (data) => {
  //TODO: Receive input value and replace dummy API
  try {
    const response = await axiosInstance.post(COURSE_ITEM_API.POST_COURSE_BOOKMARK_API, data);
    return response.data;
  } catch (error) {
    throw new Error(COURSE_ITEM_API.POST_COURSE_BOOKMARK_API_ERROR_STRING);
  }
};

export const getVODInformation = async (publicId) => {
  try {
    const response = await axiosInstance.get(`${VOD_API.GET_VOD_INFORMATION_API}/${publicId}`);
    return response.data;
  } catch (error) {
    throw new Error(VOD_API.GET_VOD_INFORMATION_API_ERROR_STRING);    
  }
}

export const getVODWaitingList = async (coursePublicId) => {
  try {
    const response = await axiosInstance.get(`${VOD_API.GET_VOD_WAITING_LIST_API}/${coursePublicId}`);
    return response.data;
  } catch (error) {
    throw new Error(VOD_API.GET_VOD_WAITING_LIST_API_ERROR_STRING);
  }
}

export const addToFavorite = async (publicId) => {
  try {
    const response = await axiosInstance.post(`${VOD_API.ADD_TO_FAVORITE_API}/${publicId}`);
    return response.data;
  } catch (error) {
    throw new Error(VOD_API.ADD_TO_FAVORITE_API_ERROR_STRING);
  }
};

export const removeFromFavorite = async (publicId) => {
  try {
    const response = await axiosInstance.delete(`${VOD_API.ADD_TO_FAVORITE_API}/${publicId}`);
    return response.data;
  } catch (error) {
    throw new Error(VOD_API.ADD_TO_FAVORITE_API_ERROR_STRING);
  }
};

export const getRatingDetailsByProductId = async (body, productId) => {
  try {
    const response = await axiosInstance.post(`${VOD_API.GET_VOD_RATING_API}/${productId}`, body);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

export const createRatingForProduct = async (body, productId) => {
  try {
    const response = await axiosInstance.post(`${VOD_API.GET_VOD_RATING_API}/${productId}/create`, body);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

export const canUserRatingForProductAsync = async (productId) => {
  try {
    const response = await axiosInstance.get(`${VOD_API.GET_VOD_RATING_API}/${productId}/can-rating`);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

export const getRatingPercent = async (productId) => {
  try {
    const response = await axiosInstance.get(`${VOD_API.GET_VOD_RATING_API}/${productId}/percent`);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

export const getSeriesSummary = async (publicId) => {
  try {
    const response = await axiosInstance.get(`${VOD_API.GET_SERIES_SUMMARY_API}/${publicId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}
